import { hasAnalyticsConsent } from './consent';

const GA_ID = 'G-PV02XVCEF1';
let injected = false;

export function loadAnalyticsIfAllowed() {
  if (injected || !hasAnalyticsConsent()) return;
  injected = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(...args) {
    window.dataLayer.push(args);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, {
    page_title: 'Games Hub',
    page_location: window.location.href,
    send_page_view: true,
  });
}

export function trackEvent(name, params) {
  if (!hasAnalyticsConsent() || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}

window.trackGameStart = function trackGameStart(gameName) {
  trackEvent('game_start', {
    game_name: gameName,
    event_category: 'gameplay',
    event_label: 'game_start',
  });
};

window.trackLanguageChange = function trackLanguageChange(language) {
  trackEvent('language_change', {
    language,
    event_category: 'user_preference',
    event_label: 'language_switch',
  });
};

window.trackPageView = function trackPageView(page) {
  trackEvent('page_view', {
    page_title: page,
    page_location: window.location.href,
  });
};
